import React from 'react';
import ReactDatePicker from 'react-datepicker';
import { format, endOfDay, startOfDay } from 'date-fns';
import { IoCloseSharp } from 'react-icons/io5';
import { useHistory } from 'react-router';
import { PropsFromRedux } from '.';
import checkImg from '../../assets/images/success-ribbons.svg';
import { API_KEYS } from '../../interfaces/api';
import { USER } from '../../interfaces/auth.interface';
import { WALLET_RESPONSE } from '../../interfaces/wallet.interface';
import { formatMoney } from '../../utils/common.utils';
import { Spinner } from '../Spinners/Spinner';


interface Props extends PropsFromRedux {}

const CodAccountStatement: React.FC<Props> = ({ 
    user,
    hideModal,
    showModal,
    modal,
    resetApi,
    accountStatement,
    accountStatementState
    
 }) => {

const userObj: USER = user?.response?.Object;
const [endDate, setEndDate] = React.useState<Date | null>(null);
const [startDate, setStartDate] = React.useState<Date | null>(null);
const statementDetails = accountStatementState?.response?.Object;

const closeModal = () => {
     hideModal();
}

React.useEffect(
  () => () => {
    resetApi(API_KEYS.GET_COD_ACCOUNT_STATEMENT);
  },
  [resetApi]
);

React.useEffect(() => {
    accountStatement(
      {
        StartDate: startDate,
        EndDate: endDate,
        CustomerCode: userObj?.UserChannelCode
      }
    );
},[accountStatement]);

React.useEffect(() => {
  if ((startDate && endDate) || (!startDate && !endDate)) {
    accountStatement(
          {
              StartDate: startDate ? startOfDay(startDate) : null,
              EndDate: endDate ? endOfDay(endDate) : null,
              CustomerCode: userObj?.UserChannelCode
          }
      );
  }
}, [endDate, accountStatement, startDate]);

return(
    <div className="w-full sm:px-12 px-12 bg-white lg:px-36 py-10 relative">
      {/* <div className="w-full bg-white relative "> */}
    
        <button type="button" aria-label="Close" onClick={closeModal}>
         <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>
      <div className="w-full border-b border-gray-300 flex items-center justify-center">
          <h3 className="text-black font-semibold pb-4">COD Bank Statement</h3>
      </div>

      {accountStatementState?.loading &&
            <div className="flex flex-col items-center justify-center">
                 <Spinner color="#CCC" />
                 <div className="font-medium text-gray-400">
                     Fetching Account Statement...
                 </div>
             </div>
        }

    {!accountStatementState?.loading && statementDetails && 
    <div className="w-full mx-auto bg-white max-w-xs rounded-md my-4 flex justify-center">
        <ReactDatePicker
            maxDate={new Date()}
            isClearable
            selectsEnd={true}
            wrapperClassName="w-full"
            calendarClassName="font-bold text-xs font-serif"
            showPopperArrow={false}
            placeholderText="Start Date"
            className="p-3 w-full border-r border-gray-100 text-sm rounded-l-md"
            selected={startDate}
            onChange={(date) => setStartDate(date as Date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
          />
          <ReactDatePicker
            maxDate={new Date()}
            isClearable
            selectsEnd={true}
            wrapperClassName="w-full"
            calendarClassName="font-bold text-xs font-serif"
            showPopperArrow={false}
            placeholderText="End Date"
            className="p-3 w-full text-sm rounded-r-md"
            selected={endDate}
            onChange={(date) => setEndDate(date as Date)}
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
          />
      </div>
    }

    {accountStatementState?.response?.Object.length == 0 &&
         <div className="w-full my-6 p-4 rounded">
            <p className=" text-sm text-gray-500 my-2 mb-6">
            Account statement not available.</p>
       </div>
    }

    {statementDetails && 
        <div className="w-full">
          {statementDetails.map((statement : any) => (
            <div key={statement.DatePaid} className="w-full border-b ">
            <div className="w-full ">
                <h4 className="text-xl font-semibold my-2">
                    {formatMoney(
                          statement.AmountPaid,
                          userObj?.Country?.CurrencyCode
                          ).replace(
                          userObj?.Country?.CurrencyCode,
                          '₦'
                      )}
                </h4>
                <h5 className="text-md font-medium text-red-500">{statement.TransactionType} . <span className="text-gray-400">{format(new Date(statement.DatePaid), 'MMM d, y')}</span></h5>
              </div>
              <div className="w-full lg:flex lg:justify-between md:flex md:justify-between mt-4">
                <h5 className="text-md text-xs text-gray-400 text">From</h5>
                <h5 className="text-md text-xs text-gray-400">To</h5>
              </div>
              <div className="w-full lg:flex lg:justify-between md:flex md:justify-between">
                    <h4 className="text-sm font-semibold">{statement.SourceAccountNumber}</h4>
                    <div className="lg:flex-initial w-64">&nbsp;</div>
                    {/* <div className="">&nbsp;</div> */}
                    <h4 className="text-sm font-semibold whitespace-nowrap">{statement.DestinationAccountNumber}</h4>

            </div>
                <div className="w-full py-2">
                    <p className=" text-md">
                    {statement.Narration}
                    </p>
                      {/* <div className="flex justify-end">
                        <p className="text-xs text-gray-400 font-medium">{statement.DestinationBankName}</p>
                      </div> */}

                </div>

                <div className="w-full my-2">
                    <p className="text-gray-400 text-xs">Narration</p>
                    <h5 className="text-gray-500 text-sm">Bill transfer</h5>
                </div>
            </div>
          )) }
        </div>
    }
      {/* <button className="w-full bg-orange-600 font-medium text-sm rounded text-white py-3" type="button" onClick={() => closeModal()}>Download Stellas Bank App</button> */}
      {statementDetails && 
         <button className="w-full bg-gray-100 font-medium text-sm font-bold rounded text-black py-3" type="button" onClick={() => closeModal()}>Go to COD Wallet</button>
      }
  </div>
  );

};

 export default CodAccountStatement;